import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

import en from 'vuetify/lib/locale/en';
import fr from 'vuetify/lib/locale/fr';

import i18n from '../i18n';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },

  lang: {
    locales: { en, fr },
    current: i18n.locale,
  },

  theme: {
    themes: {
      light: {
        primary: '#4caf50',
        // secondary: '#4caf50',
        tertiary: '#495057',
        accent: '#82B1FF',
        error: '#f55a4e',
        info: '#00d3ee',
        success: '#60ce79',
        warning: '#ffa21a'
      },
      dark: {
        primary: '#f5f5f5',
        secondary: '#f5f5f5',
        tertiary: '#f5f5f5',
        accent: '#f5f5f5',
        error: '#f55a4e',
        info: '#00d3ee',
        success: '#60ce79',
        warning: '#ffa21a'
      },
    },
  },
});
